import * as React from 'react';

import { Empty } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import {
  $linkedOrdersSelectedId,
  $linkedOrdersSelectedType,
} from '../../_state/linkedOrdersTab.state';
import { useTranslations } from '../../i18n/useTranslations';

import { PurchaseOrderDetailContent } from '~/modules/trade/_components/purchase-orders/_PurchaseOrderDetailView';
import { SalesOrderDetailContent } from '~/modules/trade/_components/salesOrders/_SalesOrderDetailView';

type LinkedOrderDetailProps = {
  onRefetch?: () => void;
};

export const LinkedOrderDetail: React.FC<LinkedOrderDetailProps> = ({
  onRefetch,
}) => {
  const t = useTranslations();
  const selectedType = useAtomValue($linkedOrdersSelectedType);
  const selectedId = useAtomValue($linkedOrdersSelectedId);

  if (!selectedId || !selectedType) {
    return (
      <Empty
        className="h-full"
        title={t.orders.detail.linkedOrders.selectOrderToView}
        centered
      />
    );
  }

  if (selectedType === 'salesOrder') {
    return (
      <div className="@EmbeddedSalesOrderDetail h-full">
        <SalesOrderDetailContent
          key={selectedId}
          salesOrderId={selectedId}
          onRefetch={onRefetch}
          variant="embedded"
        />
      </div>
    );
  }

  if (selectedType === 'purchaseOrder') {
    return (
      <div className="@EmbeddedPurchaseOrderDetail h-full">
        <PurchaseOrderDetailContent
          key={selectedId}
          purchaseOrderId={selectedId}
          onRefetch={onRefetch}
          variant="embedded"
        />
      </div>
    );
  }

  return null;
};
